import React from "react";
import { Outlet } from "react-router-dom";
import { Stack } from "@mui/material";
import { Header } from "./Header";
import Footer from "../main/Footer";

export const LandingLayout = () => {
  return (
    <>
      <Header />
      <Stack
        direction="column"
        sx={{
          minHeight: "100vh",
          bgcolor: "#fefefe",
          // Remove the top padding completely - the PageHero components will handle their own spacing
          position: 'relative'
        }}
      >
        <Outlet />
        <Footer />
      </Stack>
    </>
  );
};
